import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Process from '../components/sections/Process';
import Partners from '../components/sections/Partners';
import Contact from '../components/sections/Contact';
import Footer from '../components/layout/Footer';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Process />
      <Partners />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;